// This is a common place for vendor and consumer_rfp_vendor dashboards.
///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.common = abcsetup.dashboard.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.common.vendor = {
    init() {
        this.rfp.init();
    },

    rfp: {
        init() {
            // TODO Working around the responsive plug-in not working right now for Yajra data tables when window is resized.
            $('#rfp_outstanding,#rfp_in_review,#rfp_library').find('.datatable').css('min-width', '100%');

            this.setupBindings();
        },

        setupBindings() {
            // Retract bids from a CRFP.
            $(document).on('click', '#rfp_panel .btn-retract', event => {
                abcsetup.alerts.confirm(
                    'Retract RFP Bid(s)',
                    'Are you sure you want to retract your bid(s) from this RFP?',
                    resp => resp && this.retractBids($(event.target).closest('.btn-retract').data('id'))
                );

                return false;
            });
        },

        retractBids(ConsumerRFPId) {
            axios.post(`/api/consumer_rfp/${ConsumerRFPId}/bids/retract`).then(() => {
                $('#rfp_in_review .datatable').DataTable().ajax.reload();
                $('#rfp_outstanding .datatable').DataTable().ajax.reload();
            });
        }
    }
}
